// extracted by mini-css-extract-plugin
module.exports = {"root":"variantSelector_root__W7IeQ","notAvailable":"variantSelector_notAvailable__fZVj7"};